import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { ThemeService } from '../../services/theme.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent implements OnInit {
  public token: string | null = '';
  public eventId: string | null = '';
  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.eventId = localStorage.getItem('event_id');
    this.token = localStorage.getItem('token');
    if (this.token) {
      this.adminService.getShoppingConfig$().subscribe({
        next: (v: any) => {
          localStorage.setItem(
            'color_scheme',
            JSON.stringify(v?.payload?.color_scheme)
          );
          this.themeService.applyThemeIfAvailable();
        },
        error: (e) => {
          this.router.navigate(['/msgError'], {
            queryParams: {
              msg: e.error.error || e.error.resp,
              status: e.status,
            },
          });
        },
      });
    }
  }
}
